import React from "react";
import { Link } from "react-router-dom";
import useFetch from "../useFetch";
import "./StaticPages.css";

const money = (amount, currency = "USD") => `${currency} ${Number(amount || 0).toFixed(2)}`;

const Invoice = () => {
  const { response, isLoading, error } = useFetch(process.env.REACT_APP_BASE_API_URL + "/employer/invoices/latest");
  const invoice = response?.invoice;

  return (
    <section className="static-page-section">
      <div className="auto-container">
        <div className="static-hero">
          <h1>Invoice</h1>
          <p>Your latest employer billing receipt.</p>
        </div>

        {isLoading && <h5 className="text-center my-3">Loading Data</h5>}
        {error && <div className="alert alert-danger"><strong>{error}</strong></div>}

        {!isLoading && !error && !invoice && (
          <div className="ls-widget invoice-summary">
            <div className="widget-title">
              <h4>No Invoice Found</h4>
              <Link to="/employee-plans" className="theme-btn btn-style-three">Back to Plans</Link>
            </div>
            <div className="widget-content">
              <div className="employee-empty-state">Activate a plan to generate an invoice.</div>
            </div>
          </div>
        )}

        {invoice && (
          <div className="ls-widget invoice-summary">
            <div className="widget-title">
              <h4>Invoice #{invoice.invoice_number}</h4>
              <Link to="/employee-plans" className="theme-btn btn-style-three">Back to Plans</Link>
            </div>
            <div className="widget-content">
              <div className="static-info-grid">
                <div className="static-info-card"><span>Billed To</span><strong>{invoice.user?.name ?? "Employer"}</strong></div>
                <div className="static-info-card"><span>Date</span><strong>{invoice.paid_at ? new Date(invoice.paid_at).toLocaleDateString() : new Date(invoice.created_at).toLocaleDateString()}</strong></div>
                <div className="static-info-card"><span>Status</span><strong>{invoice.status}</strong></div>
              </div>

              <div className="admin-table-list">
                <div className="admin-table-row">
                  <div>
                    <strong>{invoice.item_name}</strong>
                    <span>{invoice.quantity_label}</span>
                  </div>
                  <span>{money(invoice.subtotal, invoice.currency)}</span>
                </div>
                <div className="admin-table-row">
                  <div>
                    <strong>Estimated Tax</strong>
                    <span>-</span>
                  </div>
                  <span>{money(invoice.tax, invoice.currency)}</span>
                </div>
              </div>

              <div className="invoice-total">
                <span>Total</span>
                <strong>{money(invoice.total, invoice.currency)}</strong>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Invoice;
